<template>
  <div class="">
    <vs-row class="marginCon">
      <vs-col vs-type="flex" vs-align="center" vs-lg="12">
        How long did this take you to complete?</vs-col
      >
    </vs-row>
    <vs-row class="marginCon">
      <vs-col vs-type="flex" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="3">
        Hours</vs-col
      >
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="3"
        vs-sm="4"
        vs-xs="7"
      >
        <vs-input-number min="0" v-model="downtime.complete.hour"
      /></vs-col>
  
      <vs-col vs-type="flex" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="3">
        Minutes</vs-col
      >
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="3"
        vs-sm="4"
        vs-xs="7"
      >
        <vs-input-number min="0" max="59" v-model="downtime.complete.minute"
      /></vs-col>
    </vs-row>
    <vs-row class="marginCon">
      <vs-col vs-type="flex" vs-align="center" vs-lg="12">
        <span>Time : {{downtime.complete.hour}} Hours {{downtime.complete.minute}} Minutes</span></vs-col
      >
    </vs-row>
    <br />
    <vs-row class="marginCon">
      <vs-col vs-type="flex" vs-align="center" vs-lg="12">
        Did this Task cause unplanned downtime?</vs-col
      >
    </vs-row>

    <vs-row class="marginCon">
      <vs-col vs-type="flex" vs-align="center" vs-lg="12">
        <vs-radio
          v-model="downtime.downtime.status"
          vs-name="false"
          vs-value="false"
          >No</vs-radio
        >
        <vs-radio
          v-model="downtime.downtime.status"
          class="ml-4"
          vs-name="true"
          vs-value="true"
          >Yes</vs-radio
        ></vs-col
      >
    </vs-row>

    <div v-if="['true'].includes(downtime.downtime.status)">
         <vs-row class="marginCon">
      <vs-col vs-type="flex" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="3">
        Hours</vs-col
      >
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="3"
        vs-sm="4"
        vs-xs="7"
      >
        <vs-input-number min="0" v-model="downtime.downtime.hour"
      /></vs-col>
  
      <vs-col vs-type="flex" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="3">
        Minutes</vs-col
      >
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="3"
        vs-sm="4"
        vs-xs="7"
      >
        <vs-input-number min="0" max="59" v-model="downtime.downtime.minute"
      /></vs-col>
    </vs-row>
    <vs-row class="marginCon">
      <vs-col vs-type="flex" vs-align="center" vs-lg="12">
        <span>Time : {{downtime.downtime.hour}} Hours {{downtime.downtime.minute}} Minutes</span></vs-col
      >
    </vs-row>
    </div>

    <!-- <pre>{{ downtime }}</pre> -->
  </div>
</template>

<script>
export default {
  props: {
    downtime: Object,
  },
  data: () => ({}),
};
</script>

<style scoped>
.marginCon {
  margin: 10px 0;
}
</style>